import { isDevelopmentEnv } from './env-helper';

const generateCSP = () => {
  const isDev = isDevelopmentEnv();

  if (isDev) {
    const devDirectives = [
      `default-src 'self' http: https: data: blob:`,
      `script-src 'self' 'unsafe-inline' 'unsafe-eval' http: https: data: blob:`,
      `style-src 'self' 'unsafe-inline' http: https: data: blob:`,
      `img-src 'self' data: blob: http: https:`,
      `worker-src 'self' blob:`,
      `font-src 'self' data: blob: http: https:`,
      `connect-src *`,
      `media-src 'self' data: blob: http: https:`,
      `frame-ancestors 'self'`,
    ];
    return devDirectives.join('; ').trim();
  }

  const defaultSrc = `'self'`;

  const scriptSources = [
    `'self'`,
    '*.rudderstack.com',
    '*.rudderlabs.com',
    'https://js.intercomcdn.com',
    'https://widget.intercom.io',
    'https://static.zdassets.com',
    'https://snippet.maze.co',
  ];

  const styleSources = [`'self'`, `'unsafe-inline'`, 'https://static.zdassets.com'];
  const imgSources = [
    defaultSrc,
    '*.amazonaws.com',
    '*.gravatar.com',
    '*.wp.com',
    '*.googleusercontent.com',
    '*.googleapis.com',
    '*.intercom.io',
    '*.intercomcdn.com',
    '*.intercomassets.com',
    '*.zendesk.com',
    'cdn.auth0.com',
    'data:',
    'blob:',
  ];

  const connectSources = [
    defaultSrc,
    '*.eppo.cloud',
    'eppo.cloud',
    '*.rudderstack.com',
    '*.rudderlabs.com',
    'wss://nexus-websocket-a.intercom.io',
    'wss://nexus-websocket-b.intercom.io',
    'https://api-iam.intercom.io',
    'https://js.intercomcdn.com',
    'https://widget.intercom.io',
    'https://browser-intake-datadoghq.com',
    '*.browser-intake-datadoghq.com',
    'https://preview.ff-cdn.datadoghq.com',
    '*.maze.co',
    'https://us-central1-eppo-qa.cloudfunctions.net',
    'https://ff-cdn.datadoghq.com',
    'https://ekr.zdassets.com',
    'https://static.zdassets.com',
    '*.zendesk.com',
    'https://id.zopim.com',
    'wss://widget-mediator.zopim.com',
  ];

  const fontSources = [
    `'self'`,
    '*.intercomcdn.com',
    'fonts.gstatic.com',
    'https://static.zdassets.com',
  ];

  const mediaSources = [`'self'`, '*.intercomcdn.com', 'https://static.zdassets.com'];

  const directives = [
    `object-src 'none'`,
    `script-src ${scriptSources.join(' ')}`,
    `base-uri 'self'`,
    `default-src ${defaultSrc} *.rudderstack.com *.rudderlabs.com api.rudderlabs.com *.intercom.io *.browser-intake-datadoghq.com *.maze.co`,
    `style-src ${styleSources.join(' ')}`,
    `img-src ${imgSources.join(' ')}`,
    `worker-src 'self' blob:`,
    `font-src ${fontSources.join(' ')}`,
    `connect-src ${connectSources.join(' ')} https://api.rudderlabs.com`,
    `media-src ${mediaSources.join(' ')}`,
    `frame-ancestors 'self'`,
  ];

  return directives.join('; ').trim();
};

export default generateCSP;
